import { useEffect } from 'react';

import { reloadHeaderBidding } from '@adverts/Sasic';

const useReloadHeaderBidding = () => {
  useEffect(() => reloadHeaderBidding(), []);
};

export default useReloadHeaderBidding;
